import { render, staticRenderFns } from "./p08.vue?vue&type=template&id=3780001c&scoped=true&"
import script from "./p08.vue?vue&type=script&lang=js&"
export * from "./p08.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3780001c",
  null
  
)

export default component.exports